export function useStringParam(key: string): string;
export function useStringParam(key: string, required: false): string | null;
export function useStringParam(key: string, required = true) {
  const route = useRoute();
  const value = route.params[key];
  if (typeof value === "string") {
    return value;
  } else if (required) {
    throw new Error(`Missing required param: ${key}`);
  } else {
    return null;
  }
}
